import {
  introBanner,
  introBannerData,
  introBannerMobile,
  webBackground,
} from "../../../assets";
import SectionWithBackground from "../../SectionWithBackground";
import { Flex, Button } from "antd";
import CurvedArrowRight from "../../../assets/layer99.png";
import { useMediaQuery } from "react-responsive";
import { getStrapiMedia, parseMarkdownBold } from "../../../helpers/tranformers";

const Intro = ({ scrollToCapabilities, content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    content && (
      <SectionWithBackground
        background={webBackground}
        applyClass="intro-background-img"
      >
        <div className="intro-flexbox">
          <Flex
            gap={isMobile ? "16px" : "85px"}
            className="intro-inner_flexbox"
          >
            <div>
              <div className="intro-title">
                {/* YOUR TRUSTED PARTNER IN RETAIL TECHNOLOGY */}
                {content?.Title}
              </div>
            </div>
            <div>
              <div
                className="intro-text"
                style={{
                  fontSize: "18px",
                  width: "370px",
                  marginTop: "13px",
                  lineHeight: "28px",
                  marginBottom: isMobile ? 0 : "48px",
                  fontWeight: "400",
                }}
              >
                {/* Empowering businesses with agile solutions,{" "}
                <strong>measurable results</strong>, and{" "}
                <strong>scalable</strong>, secure platform for a{" "}
                <strong>future-ready foundation</strong>. */}
                {parseMarkdownBold(content?.Description)}
              </div>
              <div
                style={{
                  position: "relative",
                }}
              >
                <Button
                  className="gradient-outlined-button"
                  style={{ marginTop: "20px" }}
                  onClick={scrollToCapabilities}
                >
                  EXPLORE NOW
                </Button>
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "87px",
                    height: "87px",
                    // backgroundColor: "red",
                    transform: "translate(-117%, -63%)",
                    // animation: "arrowprogress 1.5s infinite alternate"
                  }}
                  className="hide-on-mobile"
                >
                  <img
                    src={CurvedArrowRight}
                    alt="CurvedArrowRight"
                    style={{ width: "100%", height: "auto" }}
                  />
                </div>
              </div>
            </div>
          </Flex>
        </div>

        <div
          style={{
            padding: "0 25px",
            position: "relative",
            maxWidth: "1520px",
            margin: "0 auto",
          }}
        >
          {!isMobile ? (
            <img
              src={isMobile ? getStrapiMedia(content.MobileImg.url) : getStrapiMedia(content.DesktopImg.url)}
              alt="Fatser,Assurance,Experienced,cost effective"
              className="intro-banner"
              style={{
                width: "100%",
                position: "relative",
                maxWidth: "1520px",
                margin: "0 auto",
              }}
            />
          ) : (
            <div style={{ marginBottom: "100px" }}>
              <div style={{ position: "relative" }}>
                <img
                  src={getStrapiMedia(content.MobileImg.url)}
                  className="intro-banner"
                  alt="Fatser,Assurance,Experienced,cost effective"
                  style={{
                    width: "100%",
                    height: "400px",
                    borderRadius: "30px",
                    maxWidth: "1520px",
                    margin: "0 auto",
                    // objectFit: "cover",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    bottom: "-50px",
                    left: "0",
                    right: "0",
                    background: "linear-gradient(to top, #2c003e, #3b006e)",
                    color: "white",
                    padding: "1rem 1rem",
                    borderRadius: "30px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "20px",
                    }}
                  >
                    <div style={{ textAlign: "center", flex: 3 }}>
                      <div style={{ fontSize: "32px", fontWeight: "700" }}>
                        2×
                      </div>
                      <div style={{ fontSize: "18px", fontWeight: "400" }}>
                        Faster Time to market
                      </div>
                    </div>
                    <div style={{ textAlign: "center", flex: 1 }}>
                      <div style={{ fontSize: "32px", fontWeight: "700" }}>
                        .
                      </div>
                    </div>
                    <div style={{ textAlign: "center", flex: 3 }}>
                      <div
                        style={{
                          fontSize: "32px",
                          fontWeight: "700",
                        }}
                      >
                        99%+
                      </div>
                      <div style={{ fontSize: "18px", fontWeight: "400" }}>
                        Fill Rates
                      </div>
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ textAlign: "center", flex: 3 }}>
                      <div
                        style={{
                          fontSize: "32px",
                          fontWeight: "700",
                        }}
                      >
                        150+
                      </div>
                      <div style={{ fontSize: "18px", fontWeight: "400" }}>
                        Man-years of Domain Experience
                      </div>
                    </div>
                    <div style={{ textAlign: "center", flex: 1 }}>
                      <div style={{ fontSize: "32px", fontWeight: "700" }}>
                        .
                      </div>
                    </div>
                    <div style={{ textAlign: "center", flex: 3 }}>
                      <div
                        style={{
                          fontSize: "32px",
                          fontWeight: "700",
                        }}
                      >
                        50%
                      </div>
                      <div style={{ fontSize: "18px", fontWeight: "400" }}>
                        Reduction in Expenses
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* {isMobile && (
        <div
          style={{
            padding: "0 50px",
            position: "relative",
            maxWidth: "1520px",
            margin: "0 auto",
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          <img
            src={introBannerData}
            alt="Fatser,Assurance,Experienced,cost effective"
            className="intro-banner"
            style={{
              width: "80%",
              position: "relative",
              maxWidth: "1520px",
              margin: "0 auto",
            }}
          />
        </div>
      )} */}
      </SectionWithBackground>
    )
  );
};
export default Intro;
